import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return {
        tempContainer: css`
            display: inline-flex;
        `,
        numberLineLetters: css`
            line-height: ${theme.typography.h2.lineHeight};
        `,
        icon: css`
            height: ${theme.typography.h2.lineHeight};
            padding: 0px 7px;
        `,
        tempImg: css`
            width: 20px;
            height: 36px;
        `,
    }
}

export default styles
